export enum WithdrawTypeEnum {
  ACCEPT = "ACCEPT",
  REQUEST = "REQUEST",
  SALE = "SALE",
  INSTALL = "INSTALL"
}